'use client';

import { ThemeProvider } from 'next-themes';

export function Provider(props: { children?: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" forcedTheme="light" enableSystem={false}>
      {props.children}
    </ThemeProvider>
  );
}
